import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

//등록 할 디바이스 목록
export const addDeviceList = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/device-user`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
//기기등록
export const addDevice = async (token, id, name, birth) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/device-user`,
      { id, name, birth },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


//등록된 디바이스 목록
export const deviceList = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/device`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteDevice = async (device_user_id, token) => {
  try {
    const response = await axios.delete(
      `${API_BASE_URL}/device-user/${device_user_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};